// extracted by mini-css-extract-plugin
export default {"textarea":"textareaWithLabel_textarea__voxAK","flex":"textareaWithLabel_flex__KG0ug","flexMobile":"textareaWithLabel_flexMobile__E-xKY","hr":"textareaWithLabel_hr__BO1Fe"};